import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromFieldGroup from '../_reducers/fieldGroup';

export const selectFieldGroupState =
  createFeatureSelector<fromFieldGroup.FieldGroupState>('fieldGroups');

export const selectAllFieldGroups = createSelector(selectFieldGroupState, fromFieldGroup.selectAll);
